module.exports = __webpack_public_path__ + "static/media/BLZ.27bd1090.svg";